import {invoke} from "@hybird/core/bridge/hybirdBridge";
import {BridgeMethod} from "@hybird/core/bridge/core";

export class FlutterVi5300 extends BridgeMethod {
  vi5300MeasurementGetData() {
    return invoke("vi5300MeasurementGetData");
  }

  vi5300MeasurementRelease() {
    return invoke("vi5300MeasurementRelease");
  }
}

export const flutterVi5300 = new FlutterVi5300();